var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_101)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4111 33.9889C41.4111 34.4428 41.2308 34.878 40.9099 35.1989C40.589 35.5198 40.1538 35.7 39.7 35.7H24.3C23.8462 35.7 23.411 35.5198 23.0901 35.1989C22.7692 34.878 22.5889 34.4428 22.5889 33.9889V24.5778C22.5889 24.124 22.7692 23.6888 23.0901 23.3679C23.411 23.047 23.8462 22.8667 24.3 22.8667H27.7222L29.4333 20.3H34.5667L36.2778 22.8667H39.7C40.1538 22.8667 40.589 23.047 40.9099 23.3679C41.2308 23.6888 41.4111 24.124 41.4111 24.5778V33.9889Z",
    stroke: "#1A1642",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 32.2778C33.8901 32.2778 35.4222 30.7456 35.4222 28.8556C35.4222 26.9655 33.8901 25.4333 32 25.4333C30.11 25.4333 28.5778 26.9655 28.5778 28.8556C28.5778 30.7456 30.11 32.2778 32 32.2778Z",
    stroke: "#1A1642",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_101",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5333,
    height: 20.5333,
    fill: "white",
    transform: "translate(21.7333 17.7334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera_icon.a2ed10f8f8ac28ad6ce42d89d25d5e56.svg";
export { ForwardRef as ReactComponent };